import { render, staticRenderFns } from "./ObjectiveForm.vue?vue&type=template&id=030aa8cd"
import script from "./ObjectiveForm.vue?vue&type=script&lang=js"
export * from "./ObjectiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports